var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{pre:true,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{pre:true,attrs:{"fill":"currentColor","d":"M5.2,17.2a1.13,1.13,0,0,0,1.6,1.6L12,13.61l5.2,5.19a1.13,1.13,0,0,0,1.6-1.6L13.61,12,18.8,6.8a1.13,1.13,0,1,0-1.6-1.6L12,10.39,6.8,5.2A1.13,1.13,0,0,0,5.2,6.8L10.39,12Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }